import { Field, RelationAggregateOperation, VariableDefinition } from '@/explore/types';

import { ensureUniqueFieldKey } from '.';

import { ensureValidUseOfVariablesInFilterCondition } from './filter';

export const ensureValidUseOfVariablesInRelationAggregate = (
  operation: RelationAggregateOperation,
  definitions: VariableDefinition[],
): RelationAggregateOperation => {
  return operation.parameters.filter !== undefined
    ? {
        ...operation,
        parameters: {
          ...operation.parameters,
          filter: ensureValidUseOfVariablesInFilterCondition(
            operation.parameters.filter,
            definitions,
          ),
        },
      }
    : operation;
};

export const duplicateRelationAggregateOperation = (
  operation: RelationAggregateOperation,
  fields: Field[],
) => {
  return structuredClone({
    ...operation,
    parameters: {
      ...operation.parameters,
      aggregations: operation.parameters.aggregations.map((aggregation) => ({
        ...aggregation,
        property: {
          ...aggregation.property,
          key: ensureUniqueFieldKey(fields, aggregation.property.key),
        },
      })),
    },
  });
};
